import { createContext } from 'react';

export type MerchantHistoryContextData = {
	projectId: string;
};

const MerchantOrderHistoryContext = createContext<MerchantHistoryContextData>({ projectId: '' });

export default MerchantOrderHistoryContext;
